






































































































































































































































































































































	import { Component } from "../../../Infrastructure/CorBase/CoreBase";
    import NotificationPortalDetailBase from "./NotificationPortalDetailBase";

	@Component
    export default class NotificationPortalDetail extends NotificationPortalDetailBase {
		labelWidth = "3";	

		modalNameContent() {
            return this.$t('notificationPortal.modalAdd').toString()
		}
				

		mounted() {
			super.mounted();
		};

		created() {
			//TODO prava
			super.initializeRights('COR_NotificationSend_Create', 'COR_NotificationSend_Delete', 'COR_NotificationSend_Read', 'COR_NotificationSend_Update');
            super.setMainDescription('notificationPortal.description', 'notificationPortal.description');
			this.createBase();
		}

		goBackTenant() {
			this.goBackTenantBase();
		}

		deleteTenantDetail(item:any) {
            this.deleteTenantBase(item);
		}

		showModalTenants() {            
            this.showModalTenantsBase();
		}



        selectedAddTenant(items: any) {
			this.selectedAddTenantBase(items);
		}

        showModalRole() {
            this.showModalRoleBase();
		}

        goBackRole() {
            this.goBackRoleBase();
		}

        deleteRoleDetail(item: any) {
            this.deleteRoleBase(item);
		}

        selectedAddRole(items: any) {
            this.selectedAddRoleBase(items);
        }

		allowSend() {
			return this.allowSendBase();
		}

		send() {
            this.sendBase(this.sendAndSave);
		}

			 formatString(template: string, ...values: any[]): string {
				return template.replace(/{(\d+)}/g, (match, index) => values[index] || '');
			}

		contentModalSend() {
			const pocetAdresatu = this.users.length;

			return this.sendAndSave ? this.formatString(this.$t('notificationPortal.sendAndSaveMessage').toString(), pocetAdresatu)
				: this.formatString(this.$t('notificationPortal.sendMessage').toString(), pocetAdresatu);
		}

		sendAndSave = false;

		showModalSend(save: boolean) {
			this.sendAndSave = save;
            this.$bvModal.show('sendModalId');
        }
		

	}
